export enum StatusCodes {
  TOO_MANY_REQUESTS = 429,
  NO_PERMISSION = 405,
  INTERNAL_SERVER_ERROR = 500
}
